<div class="d-flex toast-container">
  <div class="toast-icon d-flex align-items-center justify-content-center">
    <div class="error-icon"></div>
  </div>
  <div class="toast-msg d-flex align-items-center">
    <div [innerHTML]="toast$.text"></div>
    <div class="closeBtn">
      <button (click)="close()" class="ml-2 mb-1 close" type="button close-btn">
        <span class="icon-Close"></span>
      </button>
    </div>
  </div>
</div>
